<div class="bulb-search-form-wrapper">
  <form name="searchForm" autocomplete="off" (ngSubmit)="onSubmit()">
    <div class="bulb-search-input-wrapper">
      <div class="input-inner-addon fa-right-align-addon">

        <a *ngIf="!loadingSuggestions" (click)="clearSearchResults()" tabindex="0" class="clear-search">
          <i class="fa fa-times"></i>
        </a>

        <input
          #searchInput
          type="text"
          [placeholder]="'search-form.search_placeholder' | transloco"
          [(ngModel)]="query"
          (ngModelChange)="onSearchChange($event)"
          (keydown)="onKeyDown($event)"
          name="query"
          [attr.aria-label]="'search-form.search_box' | transloco"
          id="search-form-query"
          class="search-input"
          [disabled]="loadingSuggestions"
        />
      </div>

      <button
        type="submit"
        class="bulb-button-inside-input"
        [disabled]="!query || loadingSuggestions">
        {{ 'search-form.search_button' | transloco }}
      </button>

      <div class="search-scope-options" *ngIf="isAuthenticated">
        <label class="search-scope-option">
          <input
            [disabled]="loadingSuggestions"
            id="searchScopeAll"
            [checked]="!includeOnlyCurrentPortfolio && !includeOnlyCurrentOrganizations"
            (click)="setSearchScope(SEARCH_SCOPES.ALL)"
            type="radio"
            name="searchScope"
          />
          <span>Search all</span>
        </label>
        <label class="search-scope-option">
          <input
            [disabled]="loadingSuggestions"
            id="includeOnlyCurrentPortfolio"
            [checked]="includeOnlyCurrentPortfolio"
            (click)="toggleOnlyCurrentPortfolio()"
            type="radio"
            name="searchScope"
          />
          <span>{{ 'search-form.search_only_portfolio' | transloco }}</span>
        </label>
        <label class="search-scope-option">
          <input
            [disabled]="loadingSuggestions"
            id="includeOnlyCurrentOrganizations"
            [checked]="includeOnlyCurrentOrganizations"
            (click)="toggleOnlyCurrentOrganizations()"
            type="radio"
            name="searchScope"
          />
          <span>Search only my organization(s)</span>
        </label>
      </div>

      <div *ngIf="loadingSuggestions"
           class="bulb-search-suggestion-list bulb-search-loading"
           aria-live="polite">
        <div class="dot-loader">
          <span class="dot dot-1"></span>
          <span class="dot dot-2"></span>
          <span class="dot dot-3"></span>
          <span class="dot dot-4"></span>
        </div>
      </div>

      <div class="bulb-search-suggestion-list" *ngIf="suggestions.length > 0"
           (scroll)="onSuggestionScroll($event)"
           style="max-height: 300px; overflow-y: auto;">
        <ul>
          <li
            *ngFor="let suggestion of suggestions"
            class="bulb-search-suggestion-item"
            (click)="setActiveSuggestion(suggestion)"
            [class.bulb-search-suggestion-active]="activeSuggestion === suggestion">
            <a [href]="'/u/' + suggestion.path">
              <span *ngIf="suggestion.authorName" class="bulb-search-suggestion-author">
                {{ suggestion.authorName }} &mdash;
              </span>
              <span class="bulb-search-suggestion-prefix">{{ getPrefix(suggestion) }}</span>
              <span class="bulb-search-suggestion">{{ stripPrefix(suggestion) }}</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </form>
</div>
